// Copyright (c) 2016 Deere & Company

import ClaimViews from '../../claim/shared/components/claim-views';

export default {
    component: ClaimViews,
    name: 'CLAIMS',
    path: 'claims'
};



// WEBPACK FOOTER //
// ./src/routes/claims/claims-root.js